import { render, staticRenderFns } from "./jqcTable.vue?vue&type=template&id=bdcbdd60&scoped=true&"
import script from "./jqcTable.vue?vue&type=script&lang=js&"
export * from "./jqcTable.vue?vue&type=script&lang=js&"
import style0 from "./jqcTable.vue?vue&type=style&index=0&id=bdcbdd60&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdcbdd60",
  null
  
)

export default component.exports